var _ = require('underscore');

var React = require("react");
var ReactDOM = require("react-dom");
const createReactClass = require("create-react-class");

const DropdownOption = require('./DropdownOption.jsx');

var UserTable = createReactClass({
	render: function() {
		var members = _.map(this.props.members, function(item) {
			var UniqueKey = item.MemberID + '-' + item.GroupID;
			return (
				<UserTableRow
					member={item}
					ejectMember={this.props.ejectMember}
					key={UniqueKey}
					roles={this.props.model.Roles}
					changeRole={this.props.changeRole}
					resetAccount={this.props.resetAccount}
				/>
			);

		}.bind(this));

		var invites = _.map(this.props.invites, function(item) {
			var UniqueKey = item.MemberID + '-' + item.GroupID;
			return (
				<UserTableInviteRow key={UniqueKey} resendInvite={this.props.resendInvite} cancelInvite={this.props.cancelInvite} member={item} />
			);
		}.bind(this));

		return (
			<div className="table-responsive">
				<table className="table">
					<thead>
						<tr>
							<th>Username</th>
							<th>Name</th>
							<th>Email</th>
							<th title="Multi-factor authentication">MFA</th>
							<th>Role</th>
							<th>&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						{members}
						{invites}
					</tbody>
				</table>
			</div>
		);
	}
});

var UserTableRow = createReactClass({
	getInitialState: function() {
		return {
			status: 'ready'
		};
	},

	componentDidMount: function() {
		this.enableTooltips();
	},

	componentDidUpdate: function() {
		this.enableTooltips();
		if(this.state.status === 'editing') {
			this.enableSelect2();
		}
	},

	enableTooltips: function() {
		$(ReactDOM.findDOMNode(this)).find('[data-toggle="tooltip"]').tooltip();

		// Also apply to elements with 'data-tooltip' due to clash with data-toggle="dropdown"
		$(ReactDOM.findDOMNode(this)).find('[data-tooltip]').tooltip();
	},

	destroyTooltips: function() {
		$(ReactDOM.findDOMNode(this)).find('[data-toggle="tooltip"]').tooltip('destroy');

		// Also apply to elements with 'data-tooltip' due to clash with data-toggle="dropdown"
		$(ReactDOM.findDOMNode(this)).find('[data-tooltip]').tooltip('destroy');
	},

	enableSelect2: function() {
		$(ReactDOM.findDOMNode(this)).find('select:not(.select2)').select2();
	},

	toggleEdit: function(e) {
		e.preventDefault();

		// Hides any open tooltips which could potentially stay open on deleted items
		this.destroyTooltips();

		if(this.state.status === 'ready') {
			this.setState({status: 'editing'});
		} else {
			this.setState({status: 'ready'});
		}
	},

	resetAccount: function(e) {
		e.preventDefault();

		this.props.resetAccount(this.props.member.MemberID);
	},

	handleEdit: function(e) {
		e.preventDefault();

		var role = ReactDOM.findDOMNode(this.refs.role);
		var result = this.props.changeRole({
			GroupID: role.value,
			MemberID: this.props.member.MemberID
		});
		if(result && this.state.status === 'editing') {
			this.toggleEdit();
		}
	},

	ejectMember: function(e) {
		e.preventDefault();
		this.props.ejectMember({
			MemberID: this.props.member.MemberID,
			GroupID: this.props.member.GroupID
		});
	},

	confirmEjectMember: function(e) {
		e.preventDefault();
		this.setState({
			status: 'confirmation'
		});
	},

	render: function() {
		const tickIcon = 'fa fa-check text-success';

		var key = this.props.member.MemberID + this.state.status;
		if(this.props.member.allowWrite && this.state.status === 'editing') {
			var roles = _.map(this.props.roles, function(item) {
				return (
					<DropdownOption value={item.GroupID} text={item.RoleTitle} key={item.GroupID} />
				);
			});
			return (
				<tr className="user-table-row" key={key}>
					<td>{this.props.member.Username}</td>
					<td>{this.props.member.FullName}</td>
					<td>{this.props.member.Email}</td>
					<td><i className={this.props.member.MFAEnabled ? tickIcon : '' } /></td>
					<td className="select2-cell">
						<select name="role" ref="role" defaultValue={this.props.member.GroupID}>
							{roles}
						</select>
					</td>
					<td className="actions">
						<button onClick={this.handleEdit} className="btn btn-primary btn-sm">Save</button>
						<button onClick={this.toggleEdit} className="cancelButton btn-link btn-sm">Cancel</button>
					</td>
				</tr>
			);
		}

		var actions = null;
		if (this.state.status === 'confirmation') {
			actions = (
				<div key={key}>
					<button
						className="btn btn-primary btn-sm"
						onClick={this.ejectMember}
					>
						Remove from Stack
					</button>
					<button
						className="cancelButton btn-link btn-sm"
						onClick={this.toggleEdit}
					>
						Cancel
					</button>
				</div>
			);
		} else if(this.props.member.allowWrite || this.props.member.allowEject) {
			actions = (
				<div className="dropdown" key={key}>
					<button
						className="dropdown-toggle btn-link btn-icon-only"
						type="button"
						data-toggle="dropdown"
						data-tooltip
						title="Options"
					>
						<i className="fa fa-cog" />
					</button>
					<div className="dropdown-menu">
						{this.props.member.managedByOrganisation ? <div className="dropdown-header">Managed by organisation</div> : null}
						{this.props.member.allowWrite ? <a className="dropdown-item" onClick={this.resetAccount}>Reset account</a> : null}
						{!this.props.member.managedByOrganisation && this.props.member.allowWrite ? <a className="dropdown-item" onClick={this.toggleEdit}>Edit role</a> : null}
						{!this.props.member.managedByOrganisation && this.props.member.allowEject ? <a className="dropdown-item" onClick={this.confirmEjectMember}>Remove from stack</a> : null}
					</div>
				</div>
			);
		} else if (this.props.member.managedByOrganisation) {
			actions = (
				<i className="fa fa-lock btn-icon-only center-block"
				   data-tooltip
				   title="Managed by your organisation" />
			)
		}

		return (
			<tr className="user-table-row">
				<td>{this.props.member.Username}</td>
				<td>{this.props.member.FullName}</td>
				<td>{this.props.member.Email}</td>
				<td><i className={this.props.member.MFAEnabled ? tickIcon : '' } /></td>
				<td>{this.props.member.RoleTitle}</td>
				<td className="actions">{actions}</td>
			</tr>
		);
	}
});

var UserTableInviteRow = createReactClass({

	getInitialState: function() {
		return {
			status: 'ready'
		};
	},

	componentDidUpdate: function() {
		this.enableTooltips();
	},

	componentDidMount: function() {
		this.enableTooltips();
	},

	enableTooltips: function() {
		$(ReactDOM.findDOMNode(this)).find('[data-toggle="tooltip"]').tooltip();
	},

	hideTooltips: function() {
		$(ReactDOM.findDOMNode(this)).find('[data-toggle="tooltip"]').tooltip('hide');
	},

	toggleStatus: function(e) {
		e.preventDefault();
		if(this.status === 'ready') {
			this.setState({status: 'confirmation'});
		} else {
			this.setState({status: 'ready'});
		}
	},

	resendInvite: function(e) {
		e.preventDefault();

		this.hideTooltips();
		this.props.resendInvite({
			Email: this.props.member.Email,
			GroupID: this.props.member.GroupID
		});

		this.setState({
			status: 'ready'
		});
	},

	cancelInvite: function(e) {
		e.preventDefault();

		this.hideTooltips();
		this.props.cancelInvite({
			GroupID: this.props.member.GroupID,
			MemberID: this.props.member.MemberID
		});
		this.setState({
			status: 'ready'
		});
	},

	confirmCancelInvite: function(e) {
		e.preventDefault();
		this.hideTooltips();
		this.setState({
			status: 'confirmation'
		});
	},

	render: function() {
		var action;
		var key = this.props.member.MemberID + '-' + this.state.status;

		if(this.state.status === 'confirmation') {
			action = (
				<div key={key}>
					<button
						className="btn btn-primary btn-sm"
						data-toggle="tooltip"
						data-placement="top"
						title="Revoke invite"
						onClick={this.cancelInvite}
					>
						Confirm
					</button>
					<button
						className="cancelButton btn-link btn-sm"
						onClick={this.toggleStatus}
					>
						Cancel
					</button>
				</div>
			);
		} else if(this.props.member.allowWrite) {
			action = (
				<div key={key}>
					<button
						onClick={this.resendInvite}
						className="btn btn-secondary btn-sm btn-icon-only"
						data-toggle="tooltip"
						data-placement="top"
						title="Resend invite"
					>
						<i className="fa fa-refresh no-text"></i>
					</button>
					<button
						onClick={this.confirmCancelInvite}
						className="btn btn-danger btn-sm btn-icon-only"
						data-toggle="tooltip"
						data-placement="top"
						title="Revoke invite"
					>
						<i className="fa fa-times no-text"></i>
					</button>
				</div>
			);
		}

		return (
			<tr className="invite-row">
				<td colSpan="2" className="text-center"><em>Invitation sent on {this.props.member.Created}</em></td>
				<td colSpan="2">{this.props.member.Email}</td>
				<td>{this.props.member.RoleTitle}</td>
				<td className="actions">{action}</td>
			</tr>
		);
	},
});

module.exports = UserTable;
